var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"https://marcribera.net","target":"_blank"}},[_vm._v("Marc Ribera")]),_vm._v(" "+_vm._s(_vm.currentYearFooter)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }